import Flickity from 'flickity';
import 'flickity-imagesloaded';

// Make an index of carousels for potential use later in theme editor
const pods_carousels = {};

// The main function that actually initializes the carousels
const initPodsCarousel = (carousel, index) => {
  const id = carousel.id;
  const data = carousel.dataset;

  let initial_index = index || 0;
  let prev_next_buttons = data.prevNextButtons === 'true';
  let page_dots = data.pageDots === 'true';
  let draggable = data.draggable === 'true';
  let wrap_around = data.wrapAround === 'true';
  let cell_align = data.cellAlign;
  let group_cells = data.groupCells === 'true';

  if (window.theme.breakpoints.current === 'mobile') {
    prev_next_buttons = data.prevNextButtonsMobile === 'true';
    page_dots = data.pageDotsMobile === 'true';
    draggable = data.draggableMobile === 'true';
    wrap_around = data.wrapAroundMobile === 'true';
    cell_align = data.cellAlignMobile;
    group_cells = data.groupCellsMobile === 'true';
  }

  if (pods_carousels[id]) {
    initial_index = pods_carousels[id].selectedIndex;
    pods_carousels[id].destroy();
    delete pods_carousels[id];
  }

  if (carousel.children.length < 1) {
    // Don't init pointless carousels with no slides
    carousel.classList.add('AnimateOnLoad--loaded');
    return;
  }

  let all_pods_visible = true;
  const initial_offset_top = carousel.children[0].getBoundingClientRect().top;

  Array.from(carousel.children).forEach((pod) => {
    if (pod.getBoundingClientRect().top !== initial_offset_top) {
      all_pods_visible = false;
    }
  });

  if (all_pods_visible) {
    wrap_around = false;
    prev_next_buttons = false;
    draggable = false;
    page_dots = false;
  }

  pods_carousels[id] = new Flickity(carousel, {
    initialIndex: initial_index,
    prevNextButtons: prev_next_buttons,
    pageDots: page_dots,
    wrapAround: wrap_around,
    cellAlign: cell_align,
    groupCells: group_cells,
    // autoPlay: data.autoPlay === 'true',
    // pauseAutoPlayOnHover: data.pauseAutoPlayOnHover === 'true',
    dragThreshold: window.theme.flickity.dragThreshold,
    adaptiveHeight: true,
    contain: true,
    imagesLoaded: true,
    draggable: draggable,
    on: {
      ready: () => {
        carousel.classList.add('AnimateOnLoad--loaded');
      },
    },
  });
};

const initPodsCarousels = () => {
  document.querySelectorAll('[data-pods-carousel]').forEach((carousel) => {
    initPodsCarousel(carousel);
  });
};

export { pods_carousels, initPodsCarousel, initPodsCarousels };
